import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const AuthorWrapper = styled.div`
  background: ${({ theme }) => theme.color.paper};
  border: 1px solid ${({ theme }) => theme.color.paper};
  border-radius: ${({ theme }) => theme.x2spacePx}px;
  padding: ${({ theme }) => theme.x3spacePx}px;
  margin-bottom: ${({ theme }) => theme.x3spacePx}px;

  h3 {
    ${({ theme }) => theme.typography.baseStrong}
    color: ${(props) => props.theme.color.noir};
    margin-left: ${({ theme }) => theme.x3spacePx}px;
  }
  p {
    ${({ theme }) => theme.typography.xSmall}
    color: ${(props) => props.theme.color.noir};
  }

  img {
    height: ${({ theme }) => theme.x8spacePx}px;
    width: ${({ theme }) => theme.x8spacePx}px;
    border-radius: 50%;
  }
`;

export const ProfileLink = styled.a`
  ${({ theme }) => theme.typography.xSmall};
  background-color: ${({ theme }) => theme.color.brand01};
  border-radius: 6px;
  color: ${({ theme }) => theme.color.white};
  padding: ${({ theme }) => `6px ${theme.x3spacePx}px`};
  text-decoration: none;
`;

export const AuthorBioSection = styled.div`
  margin-top: ${({ theme }) => theme.x2spacePx}px;
`;

export const Avatar = styled.img`
  height: ${({ theme }) => theme.x5spacePx}px;
  width: ${({ theme }) => theme.x5spacePx}px;
  // Specific size for the avatar on Desktop
  ${media.mdUp`
    height: 43px;
    width: 43px;
  `}
  border-radius: 50%;
  vertical-align: middle;
`;

export const AuthorName = styled.h3`
  flex: 1;
`;
